module.exports = __webpack_public_path__ + "static/img/bg-id.9b30e3c2.png";